export default {
  // gisUrl: 'http://101.37.64.186:8001/arcgisapi/4.9/init.js',
  //gisUrl: 'https://api.gispai.com/arcgis_js_api/3.29/',
  //gisUrl: 'https://js.arcgis.com/3.29/',
  gisUrl: 'https://server.gispai.com/MapServerAPI/arcgis_js_api/3.29/',
  // cssUrl: 'http://101.37.64.186:8001/arcgisapi/4.9/esri/css/main.css'
  //cssUrl: 'https://api.gispai.com/arcgis_js_api/3.29/esri/css/esri.css'
  //cssUrl: 'https://js.arcgis.com/3.29/esri/css/esri.css'
  cssUrl: 'https://server.gispai.com/MapServerAPI/arcgis_js_api/3.29/esri/css/esri.css'
}
